import styled, { keyframes, css } from 'styled-components';

// ── paleta (design system: teal + acentos) ─────────────────────────
const TEAL = 'var(--teal)';
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)';
const TEAL_SOFT = 'var(--teal-soft)';
const GRAY_BG = 'var(--bg)';
const GRAY_LINE = 'var(--line)';
const GRAY_TEXT = 'var(--text-muted)';
const GREEN = 'var(--green)';
const RED = 'var(--red, #dc2626)';
const AMBER = 'var(--amber, #d97706)';
//const CORAL = 'var(--coral)';
const TEAL_GLOW = 'var(--teal-glow)';

const bp = { desktop: '1024px', tablet: '768px', mobile: '540px', small: '380px' };

/*const expand = keyframes`
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
`;*/
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;

/* ── Layout base ───────────────────────────────────────────────── */
export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--bg-glow) 0%, transparent 70%),
    ${GRAY_BG};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContainerDivs = styled.div`
  width: 100%;
  max-width: 760px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px;
  gap: 14px;
  @media (max-width: ${bp.tablet}) { padding: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 8px; gap: 10px; }
`;

/* ── Cabeçalho ─────────────────────────────────────────────────── */
export const Header = styled.div`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 20px 24px;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_LIGHT} 100%);
  color: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 24px ${TEAL_GLOW};

  &::before, &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    pointer-events: none;
  }
  &::before { width: 170px; height: 170px; top: -70px; right: -40px; }
  &::after  { width: 110px; height: 110px; bottom: -55px; right: 80px; }

  @media (max-width: ${bp.mobile}) { padding: 18px; border-radius: 16px; }
`;

export const Title = styled.h1`
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  gap: 10px;
  @media (max-width: ${bp.mobile}) { font-size: 18px; }
`;

export const Subtitle = styled.span`
  position: relative;
  z-index: 1;
  display: block;
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.85;
  font-weight: 500;
`;

/* ── Card branco genérico ──────────────────────────────────────── */
export const Card = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(0,0,0,.05);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: ${fadeIn} .2s ease;

  @media (max-width: ${bp.mobile}) { padding: 16px; border-radius: 14px; }
`;

/* ── Etapa 1: seleção de data ──────────────────────────────────── */
export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${GRAY_TEXT};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DateField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  input[type="date"] {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 16px;
    color: ${TEAL_TEXT};
    outline: none;
    min-height: 48px;
    cursor: pointer;
    transition: border-color .15s ease, box-shadow .15s ease;
    &:focus { border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10,90,115,.12); }
  }
`;

/* nota informativa sobre dias letivos */
export const HelperNote = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${GRAY_TEXT};
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  gap: 6px;
`;

/* ── Botões ────────────────────────────────────────────────────── */
const buttonBase = css`
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  min-height: 48px;
  padding: 12px 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: filter .12s ease, transform .12s ease, box-shadow .12s ease;
  &:hover { filter: brightness(1.08); }
  &:active { transform: translateY(1px); }
  &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
  &:disabled { opacity: .55; cursor: not-allowed; filter: none; }
`;

export const SaveButton = styled.button`
  ${buttonBase}
  background: ${TEAL};
  color: #fff;
  box-shadow: 0 4px 12px ${TEAL_GLOW};
  width: 100%;
`;

export const Button = styled.button`
  ${buttonBase}
  background: ${GREEN};
  color: #fff;
  box-shadow: 0 4px 12px rgba(29,139,90,.22);
  width: 100%;
`;

/* ── Faixa com a data selecionada (etapa 2) ────────────────────── */
export const DateChip = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${TEAL_SOFT};
  border: 1px solid var(--teal-soft);
  border-radius: 12px;
  padding: 12px 14px;

  .icon { font-size: 20px; }
  .label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${GRAY_TEXT};
  }
  .value {
    font-size: 16px;
    font-weight: 700;
    color: ${TEAL_TEXT};
  }
  .text { display: flex; flex-direction: column; gap: 1px; }
`;

/* ── Sugestões rápidas ─────────────────────────────────────────── */
export const QuickRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuickLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${GRAY_TEXT};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const QuickChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const QuickChip = styled.button`
  border: 1px solid var(--teal-soft);
  background: ${TEAL_SOFT};
  color: ${TEAL_TEXT};
  border-radius: 999px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  min-height: 36px;
  transition: background .12s ease, transform .12s ease, border-color .12s ease;
  &:hover { background: var(--teal-soft); border-color: ${TEAL_LIGHT}; }
  &:active { transform: translateY(1px); }
  &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
`;

/* ── Editor Quill estilizado ───────────────────────────────────── */
export const EditorWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .quill {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    transition: border-color .15s ease, box-shadow .15s ease;
  }
  &:focus-within .quill {
    border-color: ${TEAL_LIGHT};
    box-shadow: 0 0 0 3px rgba(10,90,115,.12);
  }

  .ql-toolbar.ql-snow {
    border: none;
    border-bottom: 1px solid ${GRAY_LINE};
    background: ${GRAY_BG};
    border-radius: 12px 12px 0 0;
    padding: 8px 10px;
  }
  .ql-container.ql-snow {
    border: none;
    font-family: inherit;
  }
  .ql-editor {
    min-height: 220px;
    font-size: 16px;
    line-height: 1.7;
    color: var(--text-2);
    padding: 16px;
    &.ql-blank::before {
      color: #9aa7ad;
      font-style: normal;
      left: 16px;
    }
  }

  /* botões da toolbar com hover/ativo em teal */
  .ql-snow .ql-stroke { stroke: ${GRAY_TEXT}; }
  .ql-snow .ql-fill { fill: ${GRAY_TEXT}; }
  .ql-snow .ql-picker { color: ${GRAY_TEXT}; }
  .ql-snow.ql-toolbar button:hover .ql-stroke,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke,
  .ql-snow .ql-picker-label:hover { stroke: ${TEAL}; color: ${TEAL_TEXT}; }
  .ql-snow.ql-toolbar button:hover .ql-fill,
  .ql-snow.ql-toolbar button.ql-active .ql-fill { fill: ${TEAL}; }
  .ql-snow.ql-toolbar button.ql-active { background: ${TEAL_SOFT}; border-radius: 5px; }

  @media (max-width: ${bp.mobile}) {
    .ql-editor { min-height: 180px; font-size: 16px; padding: 14px; }
  }
`;

/* contador de caracteres + dica */
export const EditorFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;

  .hint {
    font-size: 12px;
    color: ${GRAY_TEXT};
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .count {
    font-size: 12px;
    font-weight: 600;
    color: ${({ $empty }) => ($empty ? GRAY_TEXT : GREEN)};
    white-space: nowrap;
  }
`;

/* ── Mensagem de erro ──────────────────────────────────────────── */
export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--red-soft);
  border: 1px solid #f5c6c0;
  color: ${RED};
  font-size: 13px;
  font-weight: 600;
  padding: 10px 14px;
  border-radius: 10px;
`;

/* ── Aviso de bimestre fechado ─────────────────────────────────── */
export const ClosedNotice = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-left: 4px solid ${AMBER};
  border-radius: 14px;
  padding: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  .icon { font-size: 38px; }
  h3 { margin: 0; color: ${TEAL_TEXT}; font-size: 17px; }
  p { margin: 0; color: ${GRAY_TEXT}; font-size: 14px; line-height: 1.5; }
`;

/* ── Voltar ────────────────────────────────────────────────────── */
export const ToGoBack = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 4px 0;
  padding: 12px;
  cursor: pointer;
  color: ${GRAY_TEXT};
  font-size: 14px;
  min-height: 44px;
  border-radius: 10px;
  transition: color .15s ease, background .15s ease;
  &:hover { color: ${TEAL_TEXT}; background: ${TEAL_SOFT}; }
`;

export const SignMessageButtonText = styled.span`
  color: inherit;
  @media (max-width: ${bp.mobile}) { font-size: 14px; }
`;

export const SignMessageButtonTextBold = styled.span`
  color: ${TEAL_TEXT};
  font-weight: 700;
  margin-left: 5px;
  @media (max-width: ${bp.mobile}) { font-size: 14px; }
`;

/* ── Compat: nomes antigos reaproveitados ──────────────────────── */
export const Label = FieldLabel;
export const InputArea = Card;
export const Input = Card;
export const InputDate = DateField;
export const StyledQuillContainer = EditorWrap;
export const Span = DateChip;
export const DescriptionContainer = styled.div``;
export const Select = styled.select``;
